<template>
  <div class="table-container overflow-auto w-full md:w-auto">
    <Table>
      <thead>
        <tr>
          <th colspan="2" class="table-header-text">
            <b>{{ itemType }}</b>
            #{{ itemId }}
            <span v-if="jobId">
              for
              <a v-if="linkJob" :href="`/jobs/${jobId}`" class="job-link">
                <b>Job</b>
                #{{ jobId }}
              </a>
              <template v-else>
                <b>Job</b>
                #{{ jobId }}
              </template>
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!!date">
          <td class="table-left-cell">{{ itemType }} Date</td>
          <td class="table-info-cell">{{ date }}</td>
        </tr>
        <tr>
          <td class="table-left-cell">Bill To</td>
          <td class="table-info-cell">
            <div class="d-flex gap-3">
              <div
                v-if="addressesMaterialized"
                class="d-flex flex-column justify-content-center"
              >
                <i
                  class="fa far fa-thumbtack"
                  :data-tippy-content="addressTooltip"
                />
              </div>
              <div>
                <div
                  v-for="line in billingNameLines"
                  :key="line"
                  class="address-label"
                >
                  {{ line }}
                </div>
                <div>{{ billingAddress }}</div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="table-left-cell">Service Address</td>
          <td class="table-info-cell">
            <div class="d-flex gap-3">
              <div
                v-if="addressesMaterialized"
                class="d-flex flex-column justify-content-center"
              >
                <i
                  class="fa far fa-thumbtack"
                  :data-tippy-content="addressTooltip"
                />
              </div>
              <div>
                <div class="address-label">
                  {{ serviceName }}
                </div>
                {{ serviceAddress }}
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </Table>
  </div>
</template>
<script setup lang="ts">
import Table from "serviceshift-ui/components/General/Table.vue";
import { computed, type PropType } from "vue";

const props = defineProps({
  itemType: {
    type: String,
    required: true
  },
  itemId: {
    type: Number,
    required: true
  },
  jobId: {
    type: Number,
    default: null
  },
  date: {
    type: String,
    required: false,
    default: null
  },
  addressesMaterialized: {
    type: Boolean,
    required: true
  },
  billingNameLines: {
    type: Array as PropType<string[]>,
    required: true
  },
  billingAddress: {
    type: String,
    required: true
  },
  serviceName: {
    type: String,
    required: true
  },
  serviceAddress: {
    type: String,
    required: true
  }
});

const linkJob = computed(() => {
  return !window.location.pathname.startsWith("/jobs/");
});

const addressTooltip = computed(() => {
  return `Address saved to ${props.itemType.toLowerCase()}.
  See "${props.itemType} Actions" => "Edit Details" to make changes.`;
});
</script>

<style scoped lang="scss">
.table-container {
  display: flex;
  align-items: flex-end;
}

tbody {
  border: 1px solid var(--primary-accent-color) !important;
}

.table td.table-left-cell {
  padding: 10px !important;
  background-color: var(--angel-blue);
  width: 110px;
  font-size: 14px;
  font-weight: bolder;
  border: 1px solid var(--medium-color) !important;
  text-align: left;
  vertical-align: top !important;
}

.table-info-cell {
  padding: 10px !important;
  background-color: white;
  font-size: 12px;
  white-space: pre-line;
  text-align: left;
  min-width: 156px;
}

.address-label {
  font-weight: bold;
}

.table-header-text {
  text-align: left;
  font-weight: normal;
}

.job-link {
  color: white;
  text-decoration: underline;
}
</style>
